import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DelegatesService } from 'src/app/services/delegates.service';
import { SpinnerService } from 'src/app/services/spinner.service';

@Component({
  selector: 'app-confirm-delegate-creation',
  templateUrl: './confirm-delegate-creation.component.html',
})
export class ConfirmDelegateCreationComponent implements OnInit {
  candidates: any[] = [];
  delegateForm: FormGroup = this.fb.group({
    id: ['', [Validators.required]],
  });

  constructor(
    private readonly modalService: NgbModal,
    private readonly activeModal: NgbActiveModal,
    private readonly fb: FormBuilder,
    private readonly delegateService: DelegatesService,
    private readonly spinnerService: SpinnerService
  ) {}

  ngOnInit(): void {
    this.spinnerService.open();
    this.delegateService.getCandidates().subscribe((data: any) => {
      this.candidates = data;
      this.spinnerService.close();
    });
  }

  closeModal() {
    this.modalService.dismissAll();
  }

  confirmCreation() {
    this.activeModal.close(this.delegateForm.value);
  }
}
